<template>
    <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="values" @submit.prevent>
        <el-form-item label="Şikəyət" prop="complaintName" label-position="top">
            <el-input v-model="this.values.complaintName"  />
        </el-form-item>
        <el-form-item label-position="top">
            <el-checkbox v-model="values.isDiaq" label="Diaqnoz"  />
        </el-form-item>
        <div class="row dialog-btn">
            <div>
                <soft-button @click="NewComplaintDet()" color="success">
                    {{ !this.editing ? 'Daxil et' : 'Qəbul et' }}</soft-button>
                &nbsp;
                <soft-button @click="this.$emit('close-dialog')" color="secondary">Imtina</soft-button>
            </div>
        </div>
    </el-form>
</template>
<script>
import SoftButton from "@/components/SoftButton.vue";
export default {
    props: {
        object: Object,
        editing: Boolean,
        id: Number
    },
    components: {
        SoftButton
    },
    data() {
        return {
            loading: false,
            values: {},
            rules: {
                complaintName: [{ required: true, message: 'Mütləq sahə', trigger: 'change' }],
            }
        }
    },
    mounted() {
        if (this.editing) {
            this.values = { ...this.object }
        }
    },
    methods: {
        NewComplaintDet() {
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) {
               //None
                }
            })
        },
    }
}
</script>